export const FontFamily = "Shabnam";
//# sourceMappingURL=index.js.map